module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-ITUNES.c23e6ad8.png";